<template>
  <ValidationObserver ref="form" v-slot="{ errors }">
    <form @submit.prevent="onSubmit($event)">
      <div class="flex items-center flex-wrap">
        <ro-h-form-parser :form-inputs="form.contact"></ro-h-form-parser>
        <transition name="fade">
          <span
            v-show="checkForErrors(errors)"
            class="w-full text-red-500 my-2 px-2"
            >*Please fill in these fields.</span
          >
        </transition>
        <b class="mx-auto flex my-4">
          <button
            class="border font-bold py-3 px-8 rounded-full focus:outline-none transition-all duration-200 ease-in-out bg-h-orange text-white hover:border-h-orange hover:bg-white hover:text-h-orange"
          >
            <span class="text-headline font-medium text-sm cursor-pointer">
              Submit
            </span>
          </button>
        </b>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import form from "./Form/ContactForm";
import { ValidationObserver } from "vee-validate";
import RoHFormParser from "@/components/Form/RoHFormParser";
import axios from "axios";
import qs from "querystring";
import { some } from "lodash";

export default {
  name: "RoHContactForm",
  components: {
    ValidationObserver,
    RoHFormParser,
  },
  props: {
    href: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form,
    };
  },
  methods: {
    getValidationRules(formInput) {
      if (!formInput.validators) {
        return null;
      }

      if (Array.isArray(formInput.validators)) {
        return formInput.validators.join("|");
      }
      return formInput.validators;
    },
    isRequired(formInput) {
      return formInput.validators && formInput.validators.includes("required");
    },
    checkForErrors(errors) {
      const errorsArray = Object.values(errors);
      if (errorsArray) {
        return some(errorsArray, (error) => {
          return error.length > 0;
        });
      }
    },
    async onSubmit() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        this.submit();
      } else {
        this.errorsLength = document.getElementsByClassName("error").length;
        const yOffset = -120;
        const element = document.getElementsByClassName("error")[0];
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });
      }
    },
    serializeFormData() {
      const data = {};
      const keys = Object.keys(this.form);
      let formElements = [];
      keys.forEach((key) => {
        formElements = formElements.concat(this.form[key]);
      });
      formElements.forEach((formElement) => {
        data[formElement.name] = formElement.value;
      });
      return data;
    },
    async submit() {
      const requestBody = {
        ...this.serializeFormData(),
      };
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      try {
        await axios.post(
          process.env.VUE_APP_BACKEND_URL +
            process.env.VUE_APP_ENDPOINT_REQUEST_ORDER,
          qs.stringify(requestBody),
          config
        );
        window.location.href = this.href;
        // eslint-disable-next-line no-empty
      } catch (err) {}
    },
  },
};
</script>

<style scoped></style>
